module.exports = __webpack_public_path__ + "assets/img/Logitech-PW-Australia-Landing-page-w720.f62b0100.webp";